import React, { FC, useRef } from 'react';

import { PlayerView } from '../../player-view/component';
import { EpisodePlayerSkin } from '../episode-player-skin/component';

import styles from './styles.module.css';

interface Props {
    contentId: string;
    filmId: string;
    seasonId: string;
    psid: string;
    onClose?: () => void;
    onSelectEpisode?: () => void;
}

export const EpisodePlayerView: FC<Props> = ({
    onClose,
    onSelectEpisode,
    contentId,
    filmId,
    seasonId,
    psid,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={containerRef} className={styles.playerContainer}>
            <PlayerView className={styles.root}>
                <EpisodePlayerSkin
                    contentId={contentId}
                    filmId={filmId}
                    seasonId={seasonId}
                    psid={psid}
                    className={styles.skin}
                    onClose={onClose}
                    onSelectEpisode={onSelectEpisode}
                    rootContainerRef={containerRef}
                />
            </PlayerView>
        </div>
    );
};
